import React from 'react';
import { Bar } from '@ant-design/charts';

export interface AreaChartDatum {
  date: string;
  category: string;
  value: number;
}

export interface AreaChartProps {
  data: AreaChartDatum[];
  title?: string;
  height?: number;
}

const AreaChart: React.FC<AreaChartProps> = ({ data, title, height = 260 }) => {
  const config: any = {
    data,
    xField: 'date',
    yField: 'value',
    colorField: 'category',
    isGroup: true,
    // Add a bit of spacing between grouped bars
    xAxis: {
      type: 'time',
      tickCount: 6,
    },
    legend: {
      position: 'top',
    },
    yAxis: {
      label: {
        formatter: (v: string) => `${v}`,
      },
    },
    tooltip: {
      title: '',
      items: [
        (datum: any) => {
          return {
            name: datum.category,
            value: datum.originalCount ?? datum.value,
          };
        },
      ],
    },
    // Match height prop
    height,
  };

  return <Bar {...config} />;
};

export default AreaChart;
